/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, BigNumberish, Overrides } from 'ethers';
import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PromiseOrValue } from '../common.js';
import type { UniswapDCABridge, UniswapDCABridgeInterface } from '../UniswapDCABridge.js';

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_rollupProcessor',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_tickSize',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_fee',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [],
    name: 'FeeTooLarge',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidCaller',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidInputA',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidOutputA',
    type: 'error',
  },
  {
    inputs: [],
    name: 'MissingImplementation',
    type: 'error',
  },
  {
    inputs: [],
    name: 'NegativePrice',
    type: 'error',
  },
  {
    inputs: [],
    name: 'NoDeposits',
    type: 'error',
  },
  {
    inputs: [],
    name: 'PositionAlreadyExists',
    type: 'error',
  },
  {
    inputs: [],
    name: 'ASSET_A',
    outputs: [
      {
        internalType: 'contract IERC20',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'ASSET_B',
    outputs: [
      {
        internalType: 'contract IERC20',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'FEE',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'FEE_DIVISOR',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'ORACLE',
    outputs: [
      {
        internalType: 'contract IChainlinkOracle',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'ROLLUP_PROCESSOR',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'SLIPPAGE',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'SUBSIDY',
    outputs: [
      {
        internalType: 'contract ISubsidy',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'TICK_SIZE',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'UNI_ROUTER',
    outputs: [
      {
        internalType: 'contract ISwapRouter',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        internalType: 'uint64',
        name: '',
        type: 'uint64',
      },
    ],
    name: 'computeCriteria',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '_inputAssetA',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '_outputAssetA',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        internalType: 'uint256',
        name: '_inputValue',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_interactionNonce',
        type: 'uint256',
      },
      {
        internalType: 'uint64',
        name: '_numTicks',
        type: 'uint64',
      },
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'convert',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'dcas',
    outputs: [
      {
        internalType: 'uint128',
        name: 'amount',
        type: 'uint128',
      },
      {
        internalType: 'uint32',
        name: 'start',
        type: 'uint32',
      },
      {
        internalType: 'uint32',
        name: 'end',
        type: 'uint32',
      },
      {
        internalType: 'bool',
        name: 'aToB',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_priceAToB',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: '_roundUp',
        type: 'bool',
      },
    ],
    name: 'denominateAssetAInB',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_priceAToB',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: '_roundUp',
        type: 'bool',
      },
    ],
    name: 'denominateAssetBInA',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [],
    name: 'earliestTickWithAvailableA',
    outputs: [
      {
        internalType: 'uint32',
        name: '',
        type: 'uint32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'earliestTickWithAvailableB',
    outputs: [
      {
        internalType: 'uint32',
        name: '',
        type: 'uint32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '_outputAssetA',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        internalType: 'uint256',
        name: '_interactionNonce',
        type: 'uint256',
      },
      {
        internalType: 'uint64',
        name: '',
        type: 'uint64',
      },
    ],
    name: 'finalise',
    outputs: [
      {
        internalType: 'uint256',
        name: 'outputValueA',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'interactionComplete',
        type: 'bool',
      },
    ],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_nonce',
        type: 'uint256',
      },
    ],
    name: 'getAccumulated',
    outputs: [
      {
        internalType: 'uint256',
        name: 'accumulated',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'ready',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getAvailable',
    outputs: [
      {
        internalType: 'uint256',
        name: 'availableA',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'availableB',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_nonce',
        type: 'uint256',
      },
    ],
    name: 'getDCA',
    outputs: [
      {
        components: [
          {
            internalType: 'uint128',
            name: 'amount',
            type: 'uint128',
          },
          {
            internalType: 'uint32',
            name: 'start',
            type: 'uint32',
          },
          {
            internalType: 'uint32',
            name: 'end',
            type: 'uint32',
          },
          {
            internalType: 'bool',
            name: 'aToB',
            type: 'bool',
          },
        ],
        internalType: 'struct BiDCABridge.DCA',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_tick',
        type: 'uint256',
      },
    ],
    name: 'getTick',
    outputs: [
      {
        components: [
          {
            internalType: 'uint120',
            name: 'availableA',
            type: 'uint120',
          },
          {
            internalType: 'uint120',
            name: 'availableB',
            type: 'uint120',
          },
          {
            internalType: 'uint16',
            name: 'poke',
            type: 'uint16',
          },
          {
            components: [
              {
                internalType: 'uint128',
                name: 'sold',
                type: 'uint128',
              },
              {
                internalType: 'uint128',
                name: 'bought',
                type: 'uint128',
              },
            ],
            internalType: 'struct BiDCABridge.SubTick',
            name: 'aToBSubTick',
            type: 'tuple',
          },
          {
            components: [
              {
                internalType: 'uint128',
                name: 'sold',
                type: 'uint128',
              },
              {
                internalType: 'uint128',
                name: 'bought',
                type: 'uint128',
              },
            ],
            internalType: 'struct BiDCABridge.SubTick',
            name: 'bToASubTick',
            type: 'tuple',
          },
          {
            internalType: 'uint128',
            name: 'priceOfAInB',
            type: 'uint128',
          },
          {
            internalType: 'uint32',
            name: 'priceTime',
            type: 'uint32',
          },
        ],
        internalType: 'struct BiDCABridge.Tick',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_numTicks',
        type: 'uint256',
      },
    ],
    name: 'pokeNextTicks',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_startTick',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_numTicks',
        type: 'uint256',
      },
    ],
    name: 'pokeTicks',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_offerA',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_offerB',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_upperTick',
        type: 'uint256',
      },
    ],
    name: 'rebalanceAndFill',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256',
      },
      {
        internalType: 'int256',
        name: '',
        type: 'int256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_offerA',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_offerB',
        type: 'uint256',
      },
    ],
    name: 'rebalanceAndFill',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256',
      },
      {
        internalType: 'int256',
        name: '',
        type: 'int256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_upperTick',
        type: 'uint256',
      },
    ],
    name: 'rebalanceAndFillUniswap',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256',
      },
      {
        internalType: 'int256',
        name: '',
        type: 'int256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'rebalanceAndFillUniswap',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256',
      },
      {
        internalType: 'int256',
        name: '',
        type: 'int256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'ticks',
    outputs: [
      {
        internalType: 'uint120',
        name: 'availableA',
        type: 'uint120',
      },
      {
        internalType: 'uint120',
        name: 'availableB',
        type: 'uint120',
      },
      {
        internalType: 'uint16',
        name: 'poke',
        type: 'uint16',
      },
      {
        components: [
          {
            internalType: 'uint128',
            name: 'sold',
            type: 'uint128',
          },
          {
            internalType: 'uint128',
            name: 'bought',
            type: 'uint128',
          },
        ],
        internalType: 'struct BiDCABridge.SubTick',
        name: 'aToBSubTick',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint128',
            name: 'sold',
            type: 'uint128',
          },
          {
            internalType: 'uint128',
            name: 'bought',
            type: 'uint128',
          },
        ],
        internalType: 'struct BiDCABridge.SubTick',
        name: 'bToASubTick',
        type: 'tuple',
      },
      {
        internalType: 'uint128',
        name: 'priceOfAInB',
        type: 'uint128',
      },
      {
        internalType: 'uint32',
        name: 'priceTime',
        type: 'uint32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    stateMutability: 'payable',
    type: 'receive',
  },
];

const _bytecode =
  '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';

type UniswapDCABridgeConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: UniswapDCABridgeConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class UniswapDCABridge__factory extends ContractFactory {
  constructor(...args: UniswapDCABridgeConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _rollupProcessor: PromiseOrValue<string>,
    _tickSize: PromiseOrValue<BigNumberish>,
    _fee: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): Promise<UniswapDCABridge> {
    return super.deploy(_rollupProcessor, _tickSize, _fee, overrides || {}) as Promise<UniswapDCABridge>;
  }
  override getDeployTransaction(
    _rollupProcessor: PromiseOrValue<string>,
    _tickSize: PromiseOrValue<BigNumberish>,
    _fee: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(_rollupProcessor, _tickSize, _fee, overrides || {});
  }
  override attach(address: string): UniswapDCABridge {
    return super.attach(address) as UniswapDCABridge;
  }
  override connect(signer: Signer): UniswapDCABridge__factory {
    return super.connect(signer) as UniswapDCABridge__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): UniswapDCABridgeInterface {
    return new utils.Interface(_abi) as UniswapDCABridgeInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): UniswapDCABridge {
    return new Contract(address, _abi, signerOrProvider) as UniswapDCABridge;
  }
}
